import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearSearchAreaBoundary,
  selectSearchAreaBoundary,
} from '@user/store/map'

export function RemoveMapBoundaryButton() {
  const dispatch = useDispatch()
  const boundary = useSelector(selectSearchAreaBoundary)

  const handleClick = useCallback(() => {
    dispatch(clearSearchAreaBoundary())
  }, [dispatch])

  if (!boundary) return null

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 28,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1,
      }}
    >
      <Button
        onClick={handleClick}
        variant="contained"
        data-test-id="removeMapBoundaryButton"
        sx={{
          backgroundColor: '#D4E3F3',
          color: '#002D5C',
          boxShadow:
            '0 1px 5px 0 rgba(14, 40, 63, 0.12), 0 2px 2px 0 rgba(14, 40, 63, 0.14), 0 3px 1px -2px rgba(14, 40, 63, 0.20)',
          '&:hover': {
            backgroundColor: '#a1c1e6',
          },
        }}
      >
        Remove Map Boundary
      </Button>
    </Box>
  )
}
